import FloatButton from '@ifca-root/react-component/src/components/Button/FloatButton'
import EmptyList from '@ifca-root/react-component/src/components/CardList/EmptyList'
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog'
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { SearchHeader } from '@ifca-root/react-component/src/components/Header/SearchHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import Loading from '@ifca-root/react-component/src/components/Loading/Loading'
import {
  CircularProgress,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Menu,
  MenuItem,
  TextField,
} from '@material-ui/core'
import { MoreVert } from '@material-ui/icons'
import ImportExportIcon from '@material-ui/icons/ImportExport'
import RepeatIcon from '@material-ui/icons/Repeat'
import { Autocomplete } from '@material-ui/lab'
import { ErrorDialog } from 'components/Dialog/ErrorDialog'
import { ExitConfirmationDialog } from 'components/Dialog/ExitConfirmationDialog'
import SnackBarContext from 'containers/App/Store/SnackBarContext'
import {
  AcctPermission,
  GetUomExchangeDataListingDocument,
  useCreateUomExchangeMutation,
  useDeleteUomExchangeMutation,
  useGetUomExchangeDataListingLazyQuery,
  useGetUomLazyQuery,
  useGetUomQuery,
  useUpdateUomExchangeMutation,
} from 'generated/graphql'
import { handleExitConfirmation } from 'helpers/Form/ExitConfirmation'
import { useMenuOption } from 'helpers/Hooks/useMenuOption'
import { usePermissionChecker } from 'helpers/Hooks/usePermissionChecker'
import { useFuseSearch } from 'helpers/Hooks/useSearch'
import { SystemMsgs } from 'helpers/Messages/SystemMsg'
import React, { useContext, useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import InfiniteScroll from 'react-infinite-scroll-component'
import NumberFormat from 'react-number-format'
import { useHistory } from 'react-router'
import './UOM.scss'

export interface ExchangeForm {
  FromUomID: {
    ID: string
    Name: string
  }
  ToUomID: {
    ID: string
    Name: string
  }
  FromAmt: number
  ToAmt: number
}

export const ConversionRateListing = props => {
  const { page } = props
  let history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const getSearch = localStorage?.getItem('searchFilter')
  const { anchorEl, menu, handleClick, handleClose } = useMenuOption()
  const [open, setOpen] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [errDialog, setErrDialog] = useState<boolean>(false)
  const [errMessage, setErrMessage] = useState<string>('')
  const [hardDeleteForm, setHardDeleteForm] = useState(false)
  const [openExitConf, setOpenExitConf] = useState(false)

  const { setOpenSnackBar, setSnackBarMsg }: any = useContext(
    SnackBarContext as any
  )

  const [TotalLength, setTotalLength] = useState(0)

  // QUERY //

  const [
    loadData,
    {
      loading: UOMExchangeDataListingLoading,
      data: { getUomExchangeDataListing } = { getUomExchangeDataListing: {} },
    },
  ] = useGetUomExchangeDataListingLazyQuery({
    fetchPolicy: 'network-only',
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: ({ getUomExchangeDataListing }) => {
      if (getUomExchangeDataListing?.Data) {
        setOriginalListing([
          ...filteredList,
          ...getUomExchangeDataListing?.Data,
        ])
      }

      if (!!getUomExchangeDataListing?.TotalLength)
        setTotalLength(getUomExchangeDataListing?.TotalLength)
    },
  })

  useEffect(() => {
    loadData({
      variables: {
        take: 30,
        skip: 0,
        ...(getSearch && { searchValue: getSearch }),
      },
    })
  }, [])

  const {
    loading: UOMLoading,
    data: { getUOM } = { getUOM: [] },
  } = useGetUomQuery({
    fetchPolicy: 'network-only',
    variables: { orderByAsc: 'Name' },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  const [
    fetchListingUOM,
    {
      loading: UOMListLoading,
      data: { getUOM: displayUomList } = { getUOM: [] },
    },
  ] = useGetUomLazyQuery({
    fetchPolicy: 'network-only',
    variables: { orderByAsc: 'Name' },
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
  })

  // MUTATION //

  const [
    createUOMExchange,
    { loading: MutationLoading },
  ] = useCreateUomExchangeMutation({
    onError: error => {
      console.log('ERROR', error)
      setErrMessage(error.message?.substring(15))
      setErrDialog(true)
      setOpen(true)
    },
    onCompleted: () => {
      setErrDialog(false)
      setOpen(false)
      reset()
      setErrMessage('none')
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.createNewRecord())
      setOriginalListing([])
      loadData({
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      })
    },
    refetchQueries: [
      {
        query: GetUomExchangeDataListingDocument,
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      },
      { query: GetUomExchangeDataListingDocument },
    ],
  })

  const [
    updateUOMExchange,
    { loading: UpdateMutationLoading },
  ] = useUpdateUomExchangeMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: () => {
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.updateRecord())
      setOpen(false)
      reset()
      setOriginalListing([])
      loadData({
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      })
    },
    refetchQueries: [
      {
        query: GetUomExchangeDataListingDocument,
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      },
      { query: GetUomExchangeDataListingDocument },
    ],
  })

  const [
    deleteUOMExchange,
    { loading: MutationDeleteUOMExchangeLoading },
  ] = useDeleteUomExchangeMutation({
    onError: ({ message }) => {
      let error = message?.substring(15)
      setErrMessage(error)
      setErrDialog(true)
    },
    onCompleted: data => {
      setHardDeleteForm(false)
      setOpenSnackBar(true)
      setSnackBarMsg(SystemMsgs.deleteRecord())
      setOriginalListing([])
      loadData({
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      })
    },
    refetchQueries: [
      {
        query: GetUomExchangeDataListingDocument,
        variables: {
          skip: 0,
          take: 30,
          ...(getSearch && { searchValue: getSearch }),
        },
      },
      { query: GetUomExchangeDataListingDocument },
    ],
  })

  const {
    handleSubmit,
    register,
    errors,
    control,
    reset,
    setValue,
    watch,
  } = useForm<ExchangeForm>({
    mode: 'all',
  })

  useEffect(() => {
    if (isEdit) fetchListingUOM()
  }, [isEdit])

  const onSubmit = data => {
    if (isEdit) {
      let fAmt = data.FromAmt ?? menu?.obj?.UomDetails?.FromAmt
      let tAmt = data.ToAmt ?? menu?.obj?.UomDetails?.ToAmt

      updateUOMExchange({
        variables: {
          input: {
            ID: menu?.obj?.ID,
            FromUomID: data.FromUomID?.ID,
            ToUomID: data.ToUomID?.ID,
            FromAmt: parseFloat(fAmt),
            ToAmt: parseFloat(tAmt),
            ExchangeRate: parseFloat(tAmt) / parseFloat(fAmt),
          },
        },
      })
    } else {
      createUOMExchange({
        variables: {
          input: {
            FromUomID: data.FromUomID?.ID,
            ToUomID: data.ToUomID?.ID,
            FromAmt: parseFloat(data.FromAmt),
            ToAmt: parseFloat(data.ToAmt),
            ExchangeRate: parseFloat(data.ToAmt) / parseFloat(data.FromAmt),
          },
        },
      })
    }
  }

  const onHardDelete = () => {
    deleteUOMExchange({
      variables: { ID: menu?.obj?.UomDetails?.ID },
      refetchQueries: [
        {
          query: GetUomExchangeDataListingDocument,
          variables: {
            skip: 0,
            take: 30,
            ...(getSearch && { searchValue: getSearch }),
          },
        },
        { query: GetUomExchangeDataListingDocument },
      ],
    })
  }

  // FILTER //

  const {
    filteredList,
    handleSearch,
    setOriginalListing,
    originalList,
  } = useFuseSearch()

  // FUNCTION //

  const fromAmount = props => {
    return (
      <Grid item xs={4}>
        <Controller
          name="FromAmt"
          className="conversion-input"
          variant="outlined"
          control={control}
          ref={register}
          defaultValue={isEdit ? parseFloat(menu?.obj?.UomDetails?.FromAmt) : 0}
          render={({ onChange, onBlur, value }) => (
            <NumberFormat
              id="standard-select-customer"
              className="conversion-input"
              variant="outlined"
              thousandSeparator
              customInput={TextField}
              fullWidth
              allowNegative={false}
              fixedDecimalScale
              decimalScale={4}
              defaultValue={
                isEdit ? parseFloat(menu?.obj?.UomDetails?.FromAmt) : 0
              }
              isNumericString
              onValueChange={values => {
                let { floatValue } = values
                onChange(
                  (value = values.floatValue),
                  register(`FromAmt`),
                  setValue(`FromAmt`, floatValue)
                )
              }}
            />
          )}
        />
      </Grid>
    )
  }

  const toAmount = props => {
    return (
      <Grid item xs={4}>
        <Controller
          className="conversion-input"
          variant="outlined"
          name="ToAmt"
          control={control}
          ref={register}
          defaultValue={isEdit ? parseFloat(menu?.obj?.UomDetails?.ToAmt) : 0}
          render={({ onChange, onBlur, value }) => (
            <NumberFormat
              id="standard-select-customer"
              className="conversion-input"
              variant="outlined"
              thousandSeparator
              customInput={TextField}
              fullWidth
              fixedDecimalScale
              decimalScale={4}
              allowNegative={false}
              defaultValue={
                isEdit ? parseFloat(menu?.obj?.UomDetails?.ToAmt) : 0
              }
              isNumericString
              onValueChange={values => {
                let { floatValue } = values
                onChange(
                  (value = values.floatValue),
                  register(`ToAmt`),
                  setValue(`ToAmt`, floatValue)
                )
              }}
            />
          )}
        />
      </Grid>
    )
  }

  const fromUom = (data, props) => {
    return (
      <Grid item xs={7}>
        <Controller
          render={({ value, onChange }) => {
            return (
              <Autocomplete
                options={data
                  ?.filter(cr => cr?.UOMID !== watch('ToUomID')?.ID)
                  ?.map(e => {
                    return {
                      ID: e?.UOMID,
                      Name: e?.Name,
                    }
                  })}
                getOptionLabel={option => `${option?.Name}`}
                fullWidth
                disabled={isEdit}
                style={{
                  paddingRight: '0px',
                }}
                value={value}
                onChange={(value, newValue: any) => {
                  onChange(newValue)
                }}
                renderInput={params => {
                  return (
                    <TextField
                      {...params}
                      style={{
                        width: '100%',
                        marginTop: '0px',
                        paddingRight: '0px',
                      }}
                      margin="normal"
                      variant="standard"
                    />
                  )
                }}
                className="conversion-dropdown-input"
              />
            )
          }}
          name="FromUomID"
          defaultValue={{
            ID: isEdit
              ? menu?.obj?.FromUomID ?? menu?.obj?.FromUomName?.UOMID
              : '',
            Name: isEdit ? menu?.obj?.FromUomName?.Name : '',
          }}
          control={control}
        />
      </Grid>
    )
  }

  const toUom = (data, props) => {
    return (
      <>
        <Grid item xs={7}>
          <Controller
            render={({ value, onChange }) => {
              return (
                <Autocomplete
                  options={data
                    ?.filter(cr => cr?.UOMID !== watch('FromUomID')?.ID)
                    ?.map(e => {
                      return {
                        ID: e?.UOMID,
                        Name: e?.Name,
                      }
                    })}
                  getOptionLabel={option => `${option?.Name}`}
                  fullWidth
                  disabled={isEdit}
                  value={value}
                  onChange={(value, newValue: any) => {
                    onChange(newValue)
                  }}
                  renderInput={params => {
                    return (
                      <TextField
                        {...params}
                        style={{ width: '100%', marginTop: '0px' }}
                        margin="normal"
                        variant="standard"
                      />
                    )
                  }}
                  className="conversion-dropdown-input"
                />
              )
            }}
            name="ToUomID"
            defaultValue={{
              ID: isEdit
                ? menu?.obj?.ToUomID ?? menu?.obj?.ToUomName?.UOMID
                : '',
              Name: isEdit ? menu?.obj?.ToUomName?.Name : '',
            }}
            control={control}
          />

          {errDialog === true && errMessage ? (
            <span style={{ color: 'red' }} className="mdDesc">
              {errMessage}
            </span>
          ) : null}
        </Grid>
      </>
    )
  }

  const disabled = () => {
    if (
      watch('FromUomID') === undefined ||
      watch('ToUomID') === undefined ||
      watch('FromAmt') === undefined ||
      watch('ToAmt') === undefined ||
      watch('FromUomID')?.ID === '' ||
      watch('ToUomID')?.ID === '' ||
      watch('FromAmt') === 0 ||
      watch('ToAmt') === 0
    ) {
      return true
    } else {
      return false
    }
  }
  useEffect(() => {
    setErrDialog(false)
  }, [watch('FromUomID')])

  useEffect(() => {
    setErrDialog(false)
  }, [watch('ToUomID')])

  const hasChanges = () =>
    handleExitConfirmation({
      watch: watch,
      editData: menu?.obj?.UomDetails,
      formMode: isEdit ? 'edit' : 'add',
    })

  const [timer, setTimer] = useState(null)
  function changeDelay(change) {
    if (timer) {
      clearTimeout(timer)
      setTimer(null)
    }

    setTimer(
      setTimeout(() => {
        setOriginalListing([])
        loadData({
          variables: {
            skip: 0,
            take: 30,
            searchValue: change,
          },
        })
      }, 1000)
    )
  }

  const { handlePermDisabled } = usePermissionChecker()

  return (
    <>
      {UOMListLoading && <Loading />}
      {MutationLoading && <Loading />}
      {UpdateMutationLoading && <Loading />}
      {UOMExchangeDataListingLoading && <Loading />}
      {MutationDeleteUOMExchangeLoading && <Loading />}
      <MainHeader
        mainBtn="back"
        onClick={() => {
          history.push('/common-setting')
        }}
        smTitle={'Common Settings'}
        title={user?.accountName}
        routeSegments={[
          { name: 'System Admin' },
          { name: 'UOM Conversion', current: true },
        ]}
      />
      <div className="search-filter with-dropdown-filter ">
        <SearchHeader
          title={`UOM Conversion Listing`}
          value={`${TotalLength}`}
          search
          onChangeAction={e => {
            // handleSearch(e?.target?.value, ['DocNo', 'JournalType.JournalType'])
            localStorage.setItem('searchFilter', e.target.value)
            changeDelay(e.target.value)
          }}
          defaultValue={getSearch ? getSearch : ''}
          isDefaultValue={!!getSearch}
          onCloseAction={() => {
            handleSearch('', [])
            localStorage.removeItem('searchFilter')
            setOriginalListing([])
            loadData({
              variables: {
                skip: 0,
                take: 30,
              },
            })
          }}
        />
      </div>
      <ContentWrapper>
        <List className="core-list">
          {filteredList === undefined || filteredList?.length === 0 ? (
            <EmptyList
              title="No Record found"
              subtitle="Add a new record now."
            />
          ) : (
            <InfiniteScroll
              dataLength={filteredList?.length}
              next={() => {
                const currentLength = filteredList?.length
                loadData({
                  variables: {
                    skip: currentLength,
                    take: 30,
                    searchValue: getSearch === '' ? undefined : getSearch,
                  },
                })
              }}
              hasMore={true}
              className=""
              style={{ padding: '8px 6px' }}
              loader={
                UOMExchangeDataListingLoading && (
                  <div style={{ textAlign: 'center' }}>
                    {' '}
                    <CircularProgress />{' '}
                  </div>
                )
              }
              endMessage={
                <p style={{ textAlign: 'center' }}>
                  <b>-</b>
                </p>
              }
            >
              {filteredList?.map((el, index) => (
                <>
                  <ListItem key={index}>
                    <ListItemText
                      primary={
                        <>
                          <span className="xsTitle">
                            {el?.FromUomName?.Name}
                          </span>
                          <RepeatIcon
                            className="repeat-icon"
                            style={{ fontSize: '0.8rem' }}
                          />
                          <span className="xsTitle">{el?.ToUomName?.Name}</span>
                        </>
                      }
                      secondary={
                        <>
                          <span className="desc flex-space">
                            {`${el?.UomDetails?.FromAmt} ${el?.FromUomName?.Code} = ${el.UomDetails?.ToAmt} ${el.ToUomName?.Code}`}
                          </span>
                        </>
                      }
                    />
                    <ListItemSecondaryAction>
                      <IconButton
                        edge="end"
                        aria-label="delete"
                        aria-controls="menu-list"
                        aria-haspopup="true"
                        onClick={e => handleClick(e, el?.ID, index, el)}
                      >
                        <MoreVert />
                      </IconButton>
                    </ListItemSecondaryAction>
                  </ListItem>
                </>
              ))}
            </InfiniteScroll>
          )}
        </List>
      </ContentWrapper>
      <Menu
        id="menu-list"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        onClick={handleClose}
      >
        <MenuItem
          disabled={
            !user?.superUser &&
            handlePermDisabled({
              permEnum: AcctPermission.CommonSettingUomExchangeUpdate,
            })
          }
          onClick={() => {
            setOpen(true)
            setIsEdit(true)
          }}
        >
          <span className="">Edit</span>
        </MenuItem>
        <MenuItem
          disabled={
            !user?.superUser &&
            handlePermDisabled({
              permEnum: AcctPermission.CommonSettingUomExchangeDelete,
            })
          }
          onClick={() => {
            setHardDeleteForm(true)
          }}
        >
          <span className="">Delete</span>
        </MenuItem>
      </Menu>
      {/* create / delete dialog */}
      <CommonDialog
        open={open}
        fullWidth={true}
        onClose={() => {
          if (hasChanges() === true) {
            setOpenExitConf(true)
          } else {
            setOpen(false)
            reset()
          }
        }}
        sections={{
          header: {
            title: 'UOM Conversion',
            rightText: isEdit ? 'Edit' : 'New',
          },
          body: () => (
            <>
              <form onSubmit={handleSubmit(onSubmit)} id="conversion-form">
                <br></br>
                <Grid container justify="flex-start">
                  {fromAmount('')}
                  <Grid item xs={1}></Grid>
                  {fromUom(isEdit ? displayUomList : getUOM, '')}
                </Grid>

                <div className="conversion-icon">
                  <ImportExportIcon />
                </div>

                <Grid container justify="flex-start">
                  {toAmount('')}
                  <Grid item xs={1}></Grid>
                  {toUom(isEdit ? displayUomList : getUOM, '')}
                </Grid>
              </form>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => {
                    if (hasChanges() === true) {
                      setOpenExitConf(true)
                    } else {
                      setOpen(false)
                      reset()
                    }
                  },
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => {
                    handleSubmit(onSubmit)
                  },
                  variant: 'contained',
                  disabled:
                    errDialog === true || disabled() === true ? true : false,
                  color: 'primary',
                  type: 'submit',
                  form: 'conversion-form',
                },
              },
            ],
          },
        }}
      />
      {/* delete dialog */}
      <CommonDialog
        fullWidth={true}
        open={hardDeleteForm}
        onClose={() => setHardDeleteForm(false)}
        sections={{
          header: { title: 'Delete UOM Conversion' },
          body: () => (
            <>
              <Grid container justify="flex-start">
                <Grid item xs={5}>
                  <div className="content-wrap ">
                    <div className="desc">From UOM</div>
                    <div className="xsTitle">
                      {menu?.obj?.UomDetails?.FromAmt}{' '}
                      {menu?.obj?.FromUomName?.Code}
                    </div>
                    <div className="xxTitle">
                      {'('}
                      {menu?.obj?.FromUomName?.Name}
                      {')'}
                    </div>
                  </div>
                </Grid>

                <Grid item xs={2}>
                  <RepeatIcon className="repeat-icon" />
                </Grid>

                <Grid item xs={5}>
                  <div className="content-wrap">
                    <div className="desc">To UOM</div>
                    <div className="xsTitle">
                      {menu?.obj?.UomDetails?.ToAmt}{' '}
                      {menu?.obj?.ToUomName?.Code}
                    </div>
                    <div className="xxTitle">
                      {'('}
                      {menu?.obj?.ToUomName?.Name}
                      {')'}
                    </div>
                  </div>
                </Grid>
              </Grid>
            </>
          ),
          footer: {
            actions: [
              {
                displayText: 'Cancel',
                props: {
                  onClick: () => setHardDeleteForm(false),
                  variant: 'contained',
                  color: 'primary',
                },
              },
              {
                displayText: 'Confirm',
                props: {
                  onClick: () => onHardDelete(),
                  variant: 'contained',
                  color: 'primary',
                  form: 'hardDeleteUOM-form',
                  type: 'submit',
                },
              },
            ],
          },
        }}
      />
      <FloatButton
        disabled={
          !user?.superUser &&
          handlePermDisabled({
            permEnum: AcctPermission.CommonSettingUomExchangeCreate,
          })
        }
        data-qa="addButton"
        onClick={() => {
          setOpen(true)
          setIsEdit(false)
        }}
      />
      <ExitConfirmationDialog
        openExitConf={openExitConf}
        setOpenExitConf={setOpenExitConf}
        onConfirm={() => {
          setOpen(false)
          setOpenExitConf(false)
          reset()
        }}
      />
      <ErrorDialog
        errorDia={errDialog}
        setErrorDia={setErrDialog}
        errorMsg={errMessage}
        errorHeaderMsg={'Error!'}
      />
    </>
  )
}
